import React from "react";



export const Industrie = () => {

   return(
    <div className="site-section block-13 " id="section-industries">

       {/* <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-md-7 text-center border-primary">
              <h2 className="mb-0 text-custom" data-aos="fade" data-aos-delay="100">Industries</h2>
              <p className="color-black-opacity-5" data-aos="fade" data-aos-delay="100">Lorem ipsum dolor sit amet.</p>
            </div>
          </div>
        </div>



        <OwlCarousel className='owl-theme'
          autoplay={true}
          responsive={{
            0: {
              items: 1
            },
            768: {
              items: 2
            },
            992: {
              items: 4
            }
          }}
          loop={true}
          dots={false}
          nav
          navClass={['owl-prev position-relative bg-white mb-10', 'owl-next position-relative bg-white']}
          navText={['<i class="fas fa-2x fa-reply" data-aos="fade" data-aos-delay="100" style="color: gold;"></i>', '<i class="fas fa-2x fa-share" data-aos="fade" data-aos-delay="100" style="color: gold;"></i>']}
        >
          <div className='item' data-aos="fade-up" data-aos-delay="100">
            <a href="#" className="unit-1 text-center">
              <img src={require(`../images/img_1.jpg`)} alt="Image" className="img-fluid" />
              <div className="unit-1-text">
                <h3 className="unit-1-heading">Storage</h3>
              </div>
            </a>
          </div>
          <div className='item' data-aos="fade-up" data-aos-delay="100">
            <a href="#" className="unit-1 text-center">
              <img src={require(`../images/img_2.jpg`)} alt="Image" className="img-fluid" />
              <div className="unit-1-text">
                <h3 className="unit-1-heading">Air Transports</h3>
              </div>
            </a>
          </div>
          <div className='item' data-aos="fade-up" data-aos-delay="100">
            <a href="#" className="unit-1 text-center">
              <img src={require(`../images/img_3.jpg`)} alt="Image" className="img-fluid" />
              <div className="unit-1-text">
                <h3 className="unit-1-heading">Cargo Transports</h3>
              </div>
            </a>
          </div>
          <div className='item' data-aos="fade-up" data-aos-delay="100">
            <a href="#" className="unit-1 text-center">
              <img src={require(`../images/img_4.jpg`)} alt="Image" className="img-fluid" />
              <div className="unit-1-text">
                <h3 className="unit-1-heading">Cargo Ship</h3>
              </div>
            </a>
          </div>
          <div className='item' data-aos="fade-up" data-aos-delay="100">
            <a href="#" className="unit-1 text-center">
              <img src={require(`../images/img_5.jpg`)} alt="Image" className="img-fluid" />
              <div className="unit-1-text">
                <h3 className="unit-1-heading">Ware Housing</h3>
              </div>
            </a>
          </div>

        </OwlCarousel>
        */}

      </div>

   )

}
export default Industrie;